import React, { PropsWithChildren } from 'react'

// components
import SalonsListPage from '../pages/SalonsListPage/SalonsListPage'

// types
import { ContextProps } from '../types/types'

// utils
import { getValidSalonsListPageQuery } from '../utils/helper'
import { salonListPageQuerySchema } from '../utils/zodQuerySchemas'

// hooks
import useZodQueryParams from '../hooks/useZodQueryParams'

type SalonsRouteProps = PropsWithChildren<ContextProps & {}>

const SalonsListRoute: React.FC<SalonsRouteProps> = (props) => {
	const [query, setQuery] = useZodQueryParams(salonListPageQuerySchema)

	/**
	 * Additional validation for query params not handled by zod
	 * e.g. dateFrom should be less than dateTo
	 */
	const validQuery = getValidSalonsListPageQuery(query)

	return <SalonsListPage {...props} query={validQuery} setQuery={setQuery} />
}

export default SalonsListRoute
